const doc = [({"da":({"js":({"tenants":({"setup":({"setup":"Opsætning"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;